import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const CollabDraftQuery: GraphQLTaggedNode = graphql`
	query CollabDraftQuery($id: ID!, $draftShareId: String = "", $hydrateAdf: Boolean) {
		collabDraft(id: $id, draftShareId: $draftShareId, hydrateAdf: $hydrateAdf) {
			document
			version
			metadata {
				title
			}
		}
	}
`;
